/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Metadata_TitleInputs */

const id_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const ms_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const da_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const de_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten`)
};

const en_us2_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const es_es2_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos`)
};

const es_mx2_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos`)
};

const fil_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const fr_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métadonnées`)
};

const it_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadati`)
};

const hu_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metaadatok`)
};

const nl_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const no_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const pl_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadane`)
};

const pt_br2_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados`)
};

const pt_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados`)
};

const ro_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadate`)
};

const fi_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metatiedot`)
};

const sv_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const vi_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siêu dữ liệu`)
};

const tr_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta Veriler`)
};

const cs_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const bg_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданни`)
};

const ru_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные`)
};

const uk_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метадані`)
};

const ar_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البيانات الوصفية`)
};

const hi_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा`)
};

const th_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมทาดาทา`)
};

const ja_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータ`)
};

const zh_cn2_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据`)
};

const zh_hant1_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中繼資料`)
};

const ko_items_metadata_title = /** @type {(inputs: Items_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메타데이터`)
};

/**
* | output |
* | --- |
* | "Metadata" |
*
* @param {Items_Metadata_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_metadata_title = /** @type {((inputs?: Items_Metadata_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Metadata_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_metadata_title(inputs)
	if (locale === "ms") return ms_items_metadata_title(inputs)
	if (locale === "da") return da_items_metadata_title(inputs)
	if (locale === "de") return de_items_metadata_title(inputs)
	if (locale === "en-US") return en_us2_items_metadata_title(inputs)
	if (locale === "es-ES") return es_es2_items_metadata_title(inputs)
	if (locale === "es-MX") return es_mx2_items_metadata_title(inputs)
	if (locale === "fil") return fil_items_metadata_title(inputs)
	if (locale === "fr") return fr_items_metadata_title(inputs)
	if (locale === "it") return it_items_metadata_title(inputs)
	if (locale === "hu") return hu_items_metadata_title(inputs)
	if (locale === "nl") return nl_items_metadata_title(inputs)
	if (locale === "no") return no_items_metadata_title(inputs)
	if (locale === "pl") return pl_items_metadata_title(inputs)
	if (locale === "pt-BR") return pt_br2_items_metadata_title(inputs)
	if (locale === "pt") return pt_items_metadata_title(inputs)
	if (locale === "ro") return ro_items_metadata_title(inputs)
	if (locale === "fi") return fi_items_metadata_title(inputs)
	if (locale === "sv") return sv_items_metadata_title(inputs)
	if (locale === "vi") return vi_items_metadata_title(inputs)
	if (locale === "tr") return tr_items_metadata_title(inputs)
	if (locale === "cs") return cs_items_metadata_title(inputs)
	if (locale === "bg") return bg_items_metadata_title(inputs)
	if (locale === "ru") return ru_items_metadata_title(inputs)
	if (locale === "uk") return uk_items_metadata_title(inputs)
	if (locale === "ar") return ar_items_metadata_title(inputs)
	if (locale === "hi") return hi_items_metadata_title(inputs)
	if (locale === "th") return th_items_metadata_title(inputs)
	if (locale === "ja") return ja_items_metadata_title(inputs)
	if (locale === "zh-CN") return zh_cn2_items_metadata_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_metadata_title(inputs)
	return ko_items_metadata_title(inputs)
});
export { items_metadata_title as "items.metadata.title" }